import { render } from "./JobsMonitor.vue?vue&type=template&id=ed76ba08&scoped=true&ts=true"
import script from "./JobsMonitor.vue?vue&type=script&lang=ts"
export * from "./JobsMonitor.vue?vue&type=script&lang=ts"

import "./JobsMonitor.vue?vue&type=style&index=0&id=ed76ba08&scoped=true&lang=scss"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed76ba08"]])

export default __exports__